import React, { useState } from 'react';
import { Link, Outlet, useLocation, Navigate } from 'react-router-dom';
import { 
  HomeIcon, 
  TicketIcon, 
  HeartIcon, 
  UserCircleIcon,
  Cog6ToothIcon,
  ArrowRightOnRectangleIcon
} from '@heroicons/react/24/outline';

const DashboardPage = () => {
  const location = useLocation();
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem('token'));
  
  // Redirect to login if not logged in
  if (!isLoggedIn) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  // Navigation items
  const navigationItems = [
    {
      name: 'Dashboard',
      icon: HomeIcon,
      to: '/dashboard',
      exact: true
    },
    {
      name: 'My Bookings',
      icon: TicketIcon,
      to: '/dashboard/bookings',
      exact: false
    },
    {
      name: 'Favorites',
      icon: HeartIcon,
      to: '/dashboard/favorites',
      exact: false
    },
    {
      name: 'Profile',
      icon: UserCircleIcon,
      to: '/dashboard/profile',
      exact: false
    },
    {
      name: 'Settings',
      icon: Cog6ToothIcon,
      to: '/dashboard/settings',
      exact: false
    }
  ];
  
  // Check if a navigation item is active
  const isActive = (path, exact = false) => {
    if (exact) {
      return location.pathname === path;
    }
    return location.pathname.startsWith(path);
  };
  
  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('token');
    setIsLoggedIn(false);
  };
  
  return (
    <div className="bg-gray-50 min-h-screen">
      <div className="container-custom py-12">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* Sidebar */}
          <div className="lg:w-1/4">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="p-6 bg-primary text-white">
                <h2 className="text-xl font-bold">User Dashboard</h2>
                <p className="text-sm opacity-80">Manage your tours and bookings</p>
              </div>
              
              <nav className="p-4">
                <ul className="space-y-2">
                  {navigationItems.map((item) => (
                    <li key={item.name}>
                      <Link
                        to={item.to}
                        className={`flex items-center px-4 py-3 rounded-md transition-colors ${
                          isActive(item.to, item.exact)
                            ? 'bg-primary-50 text-primary'
                            : 'text-gray-700 hover:bg-gray-50'
                        }`}
                      >
                        <item.icon className="h-5 w-5 mr-3" />
                        <span>{item.name}</span>
                      </Link>
                    </li>
                  ))}
                  <li className="border-t border-gray-200 mt-4 pt-4">
                    <button
                      onClick={handleLogout}
                      className="flex items-center px-4 py-3 rounded-md text-gray-700 hover:bg-gray-50 transition-colors w-full text-left"
                    >
                      <ArrowRightOnRectangleIcon className="h-5 w-5 mr-3" />
                      <span>Logout</span>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          
          {/* Main Content */}
          <div className="lg:w-3/4">
            <Outlet />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardPage;
